export enum TypeDashboard {
  HOME = "HOME",
  FINANCIER = "FINANCIER",
  PRODUCTION = "PRODUCTION",
  STOCK = "STOCK",
  SINGLE_ARTICLE = "SINGLE_ARTICLE",
  SINGLE_TIERS = "SINGLE_TIERS",
  SINGLE_LIGNE = "SINGLE_LIGNE",
  SINGLE_USER_INFOS = "SINGLE_USER_INFOS",
}
